export const ROUTES = {
    base: '/',
    products: '/products',
    aboutProduct: '/about-product',
    relatedProduct: '/related-product',
    resources: '/resources',
    cropNutritionPrograms: '/crop-nutrition-programs',
    trialResults: '/trial-results',
    detailCropNutritionPrograms: '/detail-crop-nutrition-programs',
    detailTrialResults: '/detail-trial-results',
    informationMaterials: '/information-materials',
    news: '/blog',
    research: '/research',
    article: '/article',
    career: '/career',
    detailJob: '/detail-job',
    uiKit: '/ui-kit',
    aboutUs: '/about-us',
    termsAndConditions: '/terms-and-conditions',
    legalInfo: '/legal-info',
    contacts: '/contacts',
};
